export const calendarGoToTodayIcon = `
<svg xmlns="http://www.w3.org/2000/svg" width="19" height="20" viewBox="0 0 19 20"
     fill="none">
  <path
    d="M16.625 2H15.625V0H13.625V2H5.625V0H3.625V2H2.625C1.515 2 0.635 2.9 0.635 4L0.625 18C0.625 18.5304 0.835714 19.0391 1.21079 19.4142C1.58586 19.7893 2.09457 20 2.625 20H16.625C17.725 20 18.625 19.1 18.625 18V4C18.625 2.9 17.725 2 16.625 2ZM16.625 18H2.625V7H16.625V18ZM4.625 9H9.625V14H4.625V9Z"
    fill="var(--zbp-svg-primary-color, black)"
  />
</svg>
`;
